export function DashboardHeader() {
  return (
    <header className="flex items-center justify-between py-4">
      <h1 className="text-2xl font-bold">Data Sharing Index Dashboard</h1>
    </header>
  )
}